'use strict';

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

var _ajax = require('../../utils/ajax');

var _ajax2 = _interopRequireDefault(_ajax);

var _notify = require('../../notify');

var _notify2 = _interopRequireDefault(_notify);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Returns value representing primary key of the entity displayed in table row.
 */
_jquery2.default.fn.DataTable.Api.register('row().id()', function () {
	var data = this.data();
	return data && data[this.primaryKey()];
});

/**
 * Calls OData API to delete the entity
 */
_jquery2.default.fn.DataTable.Api.register('row().delete()', function () {
	var _this = this;

	var url = this.init().ajax.url;
	var id = this.id();
	var deleteUrl = url + '(' + id + ')';
	(0, _ajax2.default)({ url: deleteUrl, method: 'DELETE' }).done(function (result) {
		_notify2.default.success(_this.i18n('notify.delete.success'));
		_this.ajax.reload(function (data) {
			if (data.value.length === 0 && _this.page() > 0) {
				_this.ajax.reload(); // reload without keeping paging
			}
		}, true);
	}).fail(function () {
		_notify2.default.error(_this.i18n('notify.delete.failed'));
	});

	(0, _jquery2.default)(this.node()).addClass('deleting');
});


//////////////////
// WEBPACK FOOTER
// ./~/linksoft/data-tables/api/row-extensions.js
// module id = 476
// module chunks = 0